export enum ThreadStatus {
    none = 0,
    active = 1,
    draft = 2,
    pending = 3,
    cancelled = 4,
    pending_cancelled = 5,
    archived = 6,
    hidden = 7,
    deleted = 8,
}
